// Product "spec lines" (spec §4.4): the sheet's blurb split into sentences.
export function specLines(blurb?: string, max = 3): string[] {
  return (blurb ?? "")
    .split(/(?<=[.!?])\s+/)
    .map((s) => s.trim().replace(/[.!?]+$/, ""))
    .filter(Boolean)
    .slice(0, max);
}
